export default __webpack_public_path__ + "static/media/about-us.3e3f66f1.jpg";